import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {Card, CardBody, CardTitle, Col, Container, Form, FormFeedback, Input, Label, Row, Table,} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import { Link } from "react-router-dom";
import {useFormik} from "formik";
import { useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import logodark from "../../assets/images/temperstack.png";

import Breadcrumbs from "../../components/Common/Breadcrumb";

import {
  emailConfirmation as onEmailConfirmation
} from "../../store/emailconfirmation/actions";

import {useParams} from "react-router";

const EmailConfirmation = (props) => {
  //meta title
  document.title = "Email Confirmation | Temperstack";

  const dispatch = useDispatch();

  const params = useParams()

  let navigate = useNavigate();

  const {confirmation_status} = useSelector(state => ({
    confirmation_status: state.EmailConfirmation.confirmation_status || '',
  }));

  useEffect( () => {
    dispatch(onEmailConfirmation(params.token));
  }, [onEmailConfirmation]);

  return (
    <React.Fragment>
      {/* <div className="account-pages my-5 pt-sm-5"> */}
        {/* <Container> */}
          {/* <Row>
            <Col lg="6">
              <Breadcrumbs
                title={"Email Confirmation"}
                breadcrumbItem={"Email Confirmation Details"}
              />
            </Col>
          </Row>
          <Row>
            <Card>
              <CardBody>
                <CardTitle>
                  {confirmation_status}
                </CardTitle>
              </CardBody>
            </Card>
          </Row> */}
          
          <Row className="pt-5">
            <Col lg={12} className="mt-5 pt-5">
              <div className="d-block text-center mb-5 text-muted">
                <Link to="/dashboard" className="d-block auth-logo">
                  <img
                    src={logodark}
                    alt=""
                    height="30"
                    className="mx-auto"
                  />
                </Link>
                <h5 className="mt-3">Welcome to Temperstack</h5>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="bg-body">
                <CardBody>
                  <div className="p-2">
                    <div className="text-center">
                      <div className="avatar-md mx-auto">
                        <div className="avatar-title rounded-circle bg-light">
                          <i className="bx bx-mail-send h1 mb-0 text-primary"></i>
                        </div>
                      </div>
                      <div className="p-2 mt-4">
                        <h4>{confirmation_status}</h4>
                        <p className="text-muted">
                          {/* At vero eos et accusamus et iusto odio dignissimos
                          ducimus qui blanditiis praesentium voluptatum
                          deleniti atque corrupti quos dolores et */}
                        </p>
                        <div className="mt-4">
                          <Link to="/login" className="btn btn-success w-md m-2">
                            Login
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} Temperstack Inc. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger"></i>
                </p>
              </div>
            </Col>
          </Row>
        {/* </Container> */}
      {/* </div> */}
    </React.Fragment>
  );
};

EmailConfirmation.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
};

export default withRouter(EmailConfirmation);